export const RECORD_AUDIO = "record_audio";
export const RECORD_VIDEO = "record_video";
export const WRITE_PARAGRAPH = "write_paragraph";
export const PRONUNCIATION = "pronunciation";
export const FILL_GRAMMAR = "fill_grammar";
export const READING_PASSAGE = "reading_passage";
export const COURSE_BASIC_PRE_IE3_5_IE_4_5 = 10;
export const LIST_SKILL_AUDIO_VIDEO = [
  { key: "fluency", name: "Fluency & Coherence" },
  { key: "vocabularyRange", name: "Lexical Resource" },
  { key: "grammaticalRange", name: "Grammatical range & Accuracy" },
  { key: "pronunciation", name: "Pronunciation" },
];

export const REASONS_BY_TYPE = {
  speaking: [
    { value: 1, label: 'Audio không nghe được' },
    { value: 2, label: 'Bài làm quá sơ sài' },
    { value: 3, label: 'Lạc đề' },
    { value: 4, label: 'Khác' }
  ],
  writing: [
    { value: 'Đạo văn', label: 'Đạo văn' },
    { value: 'Bài làm quá sơ sài', label: 'Bài làm quá sơ sài' },
    { value: 'Lạc đề', label: 'Lạc đề' },
    { value: 'Khác', label: 'Khác' }
  ]
}

export const GRADING_CRITERIA = [
  { key: 'achievement', label: 'Task Achievement' },
  { key: 'lexical', label: 'Lexical Resource' },
  { key: 'coherence', label: 'Coherence and Cohesion' },
  { key: 'grammatical', label: 'Grammatical Range and Accuracy' }
]
